import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ItemObject } from 'src/app/models/orders/item/item-object.model';
import { OrdersRouterService } from 'src/app/services/api/router/orders-router.service';
import { TabObject } from 'src/app/models/orders/item/tab-object.model';
import { TabListObject } from 'src/app/models/orders/item/tab-list-object.model';
import { TabIndexObject } from 'src/app/models/orders/item/tab-index-object.model';
import { OrderTypeObject } from 'src/app/models/orders/order-type-object.model';
import { OrderSummary } from 'src/app/services/api/orders/orders.service';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-order-product',
  templateUrl: './order-product.component.html',
  styleUrls: ['./order-product.component.scss']
})
export class OrderProductComponent implements OnInit {

  @Input() summary: OrderSummary;
  @Input() params: any;
  @Input() isps: any[];

  @Output() cancelOrderEvent = new EventEmitter();
  @Output() decompositeOrderEvent = new EventEmitter();

  private tabList: TabListObject;
  selectedIndex;

  hasBilling: boolean;

  constructor(
    private appService: AppService,
    private routerService: OrdersRouterService) {

  }

  ngOnInit() {
    this.hasBilling = this.appService.settings.hasBilling;

    this.tabList = new TabListObject();
    this.tabList.add(new TabIndexObject(0, TabObject.GENERAL_TAB));
    this.tabList.add(new TabIndexObject(1, TabObject.PRODUCT_TAB));
    this.tabList.add(new TabIndexObject(2, TabObject.PROCESSES_TAB));
    this.tabList.add(new TabIndexObject(3, TabObject.SITES_TAB));
    this.tabList.add(new TabIndexObject(4, TabObject.BILLING_TAB));
    this.tabList.add(new TabIndexObject(5, TabObject.NOTIFICATIONS_TAB));
    switch (this.params.tab) {
      case 'general':
        this.selectedIndex = 0;
        break;
      case 'product':
        this.selectedIndex = 1;
        break;
      case 'processes':
        this.selectedIndex = 2;
        break;
      case 'sites':
        this.selectedIndex = 3;
        break;
      case 'billing':
        this.selectedIndex = 4;
        break;
      case 'notifications':
        this.selectedIndex = 5;
        break;
      default:
        this.selectedIndex = 0;
        break;
    }
  }

  public goToTab($event): void {
    const tab: TabObject = this.tabList.getTab($event.index);

    this.routerService.navigate(new ItemObject(this.params.id, this.params.map, OrderTypeObject.PRODUCT, tab));

  }

  cancelOrder() {
    this.cancelOrderEvent.emit();
  }

  decompositeOrder() {
    this.decompositeOrderEvent.emit();
  }
}